/* AK26FX – Effekte für die Classic-Seiten (Discokugel, Schnee, Glitzer, Eisläufer, Kamin, Knistern).
   Reines JavaScript, keine Abhängigkeiten. Koordinaten der Bühnen-Effekte in Bildpixeln des Motivs. */
var AK26FX = (function () {
  'use strict';
  var RM = false;
  try { RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function rnd(a, b) { return a + Math.random() * (b - a); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function seeded(seed) { return function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }

  /* Canvas an CSS-Größe anpassen; maxW begrenzt die Auflösung (Bildpixel reichen). */
  function fit(cv, maxW) {
    var r = cv.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.max(1, Math.round(r.width * dpr)), h = Math.max(1, Math.round(r.height * dpr));
    if (maxW && w > maxW) { h = Math.round(h * maxW / w); w = maxW; }
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; return true; }
    return false;
  }

  /* rAF-Schleife, die nur läuft, solange das Element sichtbar ist. */
  function runner(el, frame) {
    var raf = 0, last = 0, vis = true, alive = true, t0 = performance.now(), io = null;
    function tick(now) {
      if (!alive) return;
      raf = 0;
      var dt = Math.min(0.05, (now - (last || now)) / 1000);
      last = now;
      frame((now - t0) / 1000, dt);
      if (vis && !RM) raf = requestAnimationFrame(tick);
    }
    function kick() { if (!raf && alive) { last = 0; raf = requestAnimationFrame(tick); } }
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (en) { vis = en[0].isIntersecting; if (vis) kick(); }, { rootMargin: '120px' });
      io.observe(el);
    }
    kick();
    return {
      kick: kick,
      stop: function () { alive = false; if (raf) cancelAnimationFrame(raf); if (io) io.disconnect(); }
    };
  }

  /* ---------------- Discokugel ---------------- */
  /* Grundfarbe je Fliese aus dem echten Kugelbild (env, kleines Bild als data-URI),
     Fliesen drehen sich, leicht verkippte Fliesen blitzen in den Lichtzonen auf. */
  function norm(v) { var l = Math.sqrt(v[0] * v[0] + v[1] * v[1] + v[2] * v[2]) || 1; return [v[0] / l, v[1] / l, v[2] / l]; }
  function lightFor(sx, sy) { var nz = Math.sqrt(Math.max(0, 1 - sx * sx - sy * sy)); return [2 * nz * sx, 2 * nz * sy, 2 * nz * nz - 1]; }
  function discoBall(cv, opt) {
    opt = opt || {};
    var ctx = cv.getContext('2d');
    var rand = seeded(19);
    var NL = opt.bands || 28, tiles = [];
    for (var i = 0; i < NL; i++) {
      var la0 = -Math.PI / 2 + i * Math.PI / NL, la1 = la0 + Math.PI / NL, lc = (la0 + la1) / 2;
      var n = Math.max(6, Math.round(2 * NL * Math.cos(lc)));
      var off = rand() * Math.PI * 2 / n;
      for (var j = 0; j < n; j++) {
        tiles.push({ la0: la0, la1: la1, lo0: off + j * 2 * Math.PI / n, lo1: off + (j + 1) * 2 * Math.PI / n,
          jx: (rand() - 0.5) * 0.15, jy: (rand() - 0.5) * 0.15, b: 0.78 + rand() * 0.42 });
      }
    }
    var EN = 0, ED = null;
    if (opt.env) {
      var ei = new Image();
      ei.onload = function () { try { var c = document.createElement('canvas'); c.width = ei.width; c.height = ei.height; var x = c.getContext('2d'); x.drawImage(ei, 0, 0); ED = x.getImageData(0, 0, c.width, c.height).data; EN = c.width; } catch (e) { ED = null; } };
      ei.src = opt.env;
    }
    function sample(sx, sy, out) {
      if (!ED) { var up = -sy; out[0] = up > 0 ? 190 : 236; out[1] = up > 0 ? 196 : 170; out[2] = up > 0 ? 194 : 120; return; }
      var u = clamp((sx * 0.5 + 0.5) * (EN - 1), 0, EN - 1.001), v = clamp((sy * 0.5 + 0.5) * (EN - 1), 0, EN - 1.001);
      var x0 = u | 0, y0 = v | 0, fx = u - x0, fy = v - y0;
      for (var c = 0; c < 3; c++) {
        var a = ED[(y0 * EN + x0) * 4 + c], b = ED[(y0 * EN + x0 + 1) * 4 + c], d = ED[((y0 + 1) * EN + x0) * 4 + c], e = ED[((y0 + 1) * EN + x0 + 1) * 4 + c];
        out[c] = (a * (1 - fx) + b * fx) * (1 - fy) + (d * (1 - fx) + e * fx) * fy;
      }
    }
    var LS = [lightFor(0.50, 0.19), lightFor(-0.12, 0.22), lightFor(0.05, -0.55), lightFor(-0.62, 0.05)];
    var LW = [1.6, 1.2, 0.8, 0.7];
    var party = false, speed = 0.3, target = 0.3, rot = 0, glints = [], col = [0, 0, 0], self = {};
    function draw(t, dt) {
      fit(cv, 640);
      var W = cv.width, H = cv.height, cx = W / 2, cy = H / 2, R = W * (opt.r || 0.385);
      speed += (target - speed) * Math.min(1, dt * 2);
      rot += speed * dt;
      ctx.clearRect(0, 0, W, H);
      ctx.save();
      ctx.beginPath(); ctx.arc(cx, cy, R + 0.6, 0, Math.PI * 2);
      ctx.fillStyle = '#3A332D'; ctx.fill();
      ctx.clip();
      glints.length = 0;
      var gap = Math.PI / NL * 0.05;
      for (var k = 0; k < tiles.length; k++) {
        var f = tiles[k];
        var lc = (f.lo0 + f.lo1) / 2 + rot, ac = (f.la0 + f.la1) / 2;
        var ca = Math.cos(ac), nz = ca * Math.cos(lc);
        if (nz < 0.03) continue;
        var nx = ca * Math.sin(lc), ny = Math.sin(ac);
        sample(nx, -ny, col);
        var n2 = norm([nx + f.jx, ny + f.jy, nz]);
        var r0 = 2 * n2[2] * n2[0], r1 = 2 * n2[2] * n2[1], r2 = 2 * n2[2] * n2[2] - 1;
        var spec = 0;
        for (var li = 0; li < 4; li++) { var L = LS[li]; var d = r0 * L[0] + r1 * L[1] + r2 * L[2]; if (d > 0.9) spec += Math.pow(d, 260) * LW[li]; }
        var sh = (1 + (f.b - 1) * 0.8) * (0.9 + 0.1 * nz) * 1.12;
        var lum = 0.3 * col[0] + 0.59 * col[1] + 0.11 * col[2];
        if (lum > 200) { var wv = Math.min(1, (lum - 200) / 40) * 0.6; col[0] += (255 - col[0]) * wv; col[1] += (255 - col[1]) * wv; col[2] += (255 - col[2]) * wv; }
        if (ny > 0.05) { col[0] *= 0.97; col[2] = Math.min(255, col[2] * 1.07); }
        var cr = col[0] * sh + spec * 255, cg = col[1] * sh + spec * 250, cb = col[2] * sh + spec * 235;
        var a0 = f.la0 + gap, a1 = f.la1 - gap, o0 = f.lo0 + gap + rot, o1 = f.lo1 - gap + rot;
        var c0 = Math.cos(a0), c1 = Math.cos(a1), s0 = Math.sin(a0), s1 = Math.sin(a1);
        ctx.beginPath();
        ctx.moveTo(cx + R * c0 * Math.sin(o0), cy - R * s0);
        ctx.lineTo(cx + R * c0 * Math.sin(o1), cy - R * s0);
        ctx.lineTo(cx + R * c1 * Math.sin(o1), cy - R * s1);
        ctx.lineTo(cx + R * c1 * Math.sin(o0), cy - R * s1);
        ctx.closePath();
        ctx.fillStyle = 'rgb(' + Math.min(255, cr | 0) + ',' + Math.min(255, cg | 0) + ',' + Math.min(255, cb | 0) + ')';
        ctx.fill();
        if (spec > 0.45) glints.push([cx + R * nx, cy - R * ny, Math.min(1.3, spec)]);
      }
      var g1 = ctx.createRadialGradient(cx - R * 0.15, cy - R * 0.2, R * 0.55, cx, cy, R * 1.01);
      g1.addColorStop(0, 'rgba(0,0,0,0)'); g1.addColorStop(1, 'rgba(20,14,10,0.26)');
      ctx.fillStyle = g1; ctx.fillRect(cx - R, cy - R, 2 * R, 2 * R);
      ctx.restore();
      ctx.save();
      ctx.globalCompositeOperation = 'lighter';
      glints.sort(function (a, b) { return b[2] - a[2]; });
      var ng = Math.min(glints.length, party ? 8 : 5);
      for (var m = 0; m < ng; m++) star(ctx, glints[m][0], glints[m][1], R * (0.18 + 0.4 * glints[m][2]) * (party ? 1.2 : 1), Math.min(1, glints[m][2]), t * 0.3 + m);
      ctx.restore();
    }
    var run = runner(cv, draw);
    self.setParty = function (on) { party = !!on; target = on ? 0.9 : 0.3; run.kick(); };
    self.angle = function () { return rot; };
    self.destroy = function () { run.stop(); };
    return self;
  }

  function star(ctx, x, y, len, a, tw) {
    var g = ctx.createRadialGradient(x, y, 0, x, y, len * 0.28);
    g.addColorStop(0, 'rgba(255,255,255,' + (0.95 * a) + ')');
    g.addColorStop(0.35, 'rgba(255,250,235,' + (0.45 * a) + ')');
    g.addColorStop(1, 'rgba(255,240,210,0)');
    ctx.fillStyle = g;
    ctx.beginPath(); ctx.arc(x, y, len * 0.28, 0, Math.PI * 2); ctx.fill();
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(0.08 * Math.sin(tw));
    for (var i = 0; i < 4; i++) {
      var L = (i % 2 ? 0.55 : 1) * len, w = Math.max(0.6, len * 0.035);
      var gl = ctx.createLinearGradient(0, 0, L, 0);
      gl.addColorStop(0, 'rgba(255,255,255,' + (0.9 * a) + ')');
      gl.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = gl;
      ctx.beginPath(); ctx.moveTo(0, -w); ctx.lineTo(L, 0); ctx.lineTo(0, w); ctx.closePath(); ctx.fill();
      ctx.rotate(Math.PI / 2);
    }
    ctx.rotate(Math.PI / 4);
    for (var k = 0; k < 4; k++) {
      var L2 = len * 0.32, w2 = Math.max(0.5, len * 0.022);
      var g2 = ctx.createLinearGradient(0, 0, L2, 0);
      g2.addColorStop(0, 'rgba(255,255,255,' + (0.6 * a) + ')');
      g2.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = g2;
      ctx.beginPath(); ctx.moveTo(0, -w2); ctx.lineTo(L2, 0); ctx.lineTo(0, w2); ctx.closePath(); ctx.fill();
      ctx.rotate(Math.PI / 2);
    }
    ctx.restore();
  }

  /* Lichtpunkte der Kugel auf Wand und Boden. Bühne = ganzes Motiv (img: Bildbreite). */
  function discoSpots(cv, opt) {
    var ctx = cv.getContext('2d');
    var IW = opt.img || 1441, bx = opt.ball[0], by = opt.ball[1], horizon = opt.horizon || 600;
    var rand = seeded(7), spots = [];
    for (var i = 0; i < 170; i++) spots.push({ az: rand() * Math.PI * 2, e: rand() * 2 - 1, s: 0.6 + rand() * 0.9, a: 0.35 + rand() * 0.5, warm: rand() < 0.45 });
    var on = false, level = 0, ballRef = opt.ballRef;
    function draw(t, dt) {
      level += ((on ? 1 : 0) - level) * Math.min(1, dt * 2.5);
      fit(cv, 900);
      var W = cv.width, H = cv.height, k = W / IW;
      ctx.clearRect(0, 0, W, H);
      if (level < 0.01) return;
      var rot = ballRef ? ballRef.angle() : t * 0.9;
      ctx.save();
      ctx.globalCompositeOperation = 'lighter';
      for (var i = 0; i < spots.length; i++) {
        var p = spots[i], az = p.az + rot * 1.0, x, y, w, h, vis;
        if (p.e > 0.12) {
          // Wand hinter der Kugel
          vis = -Math.cos(az);
          if (vis <= 0) continue;
          x = bx + Math.sin(az) * IW * 0.62;
          y = by - (p.e - 0.12) * 520 + 40;
          if (y > horizon - 6 || y < 0) continue;
          w = 12 * p.s; h = 12 * p.s;
        } else {
          // Boden, Ellipsen um den Punkt unter der Kugel
          var ring = 0.15 + (p.e + 1) / 1.12 * 1.05;
          x = bx + Math.sin(az) * IW * 0.55 * ring;
          y = horizon + 30 + (Math.cos(az) * 0.5 + 0.5) * 760 * ring * 0.62;
          vis = 1;
          var persp = 0.6 + (y - horizon) / 700;
          w = 30 * p.s * persp; h = 11 * p.s * persp;
          if (y < horizon + 4) continue;
        }
        var a = Math.min(1, p.a * level * vis * 1.05);
        var X = x * k, Y = y * k, ww = w * k, hh = h * k;
        var c = p.warm ? '255,236,200' : '255,255,255';
        ctx.fillStyle = 'rgba(' + c + ',' + (a * 0.28) + ')';
        ctx.fillRect(X - ww * 0.75, Y - hh * 0.75, ww * 1.5, hh * 1.5);
        ctx.fillStyle = 'rgba(' + c + ',' + (a * 0.75) + ')';
        ctx.fillRect(X - ww / 2, Y - hh / 2, ww, hh);
      }
      ctx.restore();
    }
    var run = runner(cv, draw);
    return {
      setOn: function (v) { on = !!v; run.kick(); },
      destroy: function () { run.stop(); }
    };
  }

  /* ---------------- Schneeflocken ---------------- */
  function flakeSprite(size, seed, soft) {
    var c = document.createElement('canvas'); c.width = c.height = size;
    var x = c.getContext('2d'), r = seeded(seed), R = size * 0.39;
    x.translate(size / 2, size / 2);
    x.lineCap = 'round'; x.lineJoin = 'round';
    var lw = Math.max(1, size / (soft ? 22 : 44));
    x.strokeStyle = soft ? 'rgba(255,255,255,0.8)' : '#FFFFFF';
    x.fillStyle = 'rgba(255,255,255,0.22)';
    x.shadowColor = soft ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.7)';
    x.shadowBlur = soft ? size / 12 : size / 26;
    var type = seed % 4;
    function arm() {
      x.lineWidth = lw * 1.25;
      x.beginPath(); x.moveTo(0, 0); x.lineTo(0, -R); x.stroke();
      x.lineWidth = lw;
      if (type === 0) {
        var nb = 3 + Math.floor(r() * 2);
        for (var i = 0; i < nb; i++) {
          var py = -(0.3 + i * (0.6 / nb)) * R, L = (0.34 - i * 0.06) * R * (0.85 + r() * 0.3);
          for (var sgn = -1; sgn <= 1; sgn += 2) {
            var ex = sgn * L * 0.866, ey = py - L * 0.5;
            x.beginPath(); x.moveTo(0, py); x.lineTo(ex, ey); x.stroke();
            var tw = L * 0.38, mx = ex * 0.55, my = py + (ey - py) * 0.55;
            x.beginPath(); x.moveTo(mx, my); x.lineTo(mx + sgn * tw * 0.2, my - tw); x.stroke();
          }
        }
      } else if (type === 1) {
        x.beginPath();
        x.moveTo(0, -R * 0.18); x.lineTo(-R * 0.16, -R * 0.42); x.lineTo(0, -R * 0.66); x.lineTo(R * 0.16, -R * 0.42); x.closePath();
        x.fill(); x.stroke();
        x.beginPath(); x.moveTo(-R * 0.1, -R * 0.75); x.lineTo(0, -R * 0.9); x.lineTo(R * 0.1, -R * 0.75); x.stroke();
        for (var k = 0; k < 2; k++) { var yy = -(0.72 + k * 0.1) * R; x.beginPath(); x.moveTo(-R * 0.08, yy + R * 0.05); x.lineTo(0, yy); x.lineTo(R * 0.08, yy + R * 0.05); x.stroke(); }
      } else if (type === 2) {
        for (var f = 0; f < 8; f++) {
          var fy = -(0.18 + f * 0.095) * R, fl = (0.2 - f * 0.018) * R;
          x.beginPath(); x.moveTo(-fl * 0.866, fy - fl * 0.5); x.lineTo(0, fy); x.lineTo(fl * 0.866, fy - fl * 0.5); x.stroke();
        }
      } else {
        x.beginPath(); x.moveTo(0, -R * 0.5); x.lineTo(-R * 0.22, -R * 0.68); x.moveTo(0, -R * 0.5); x.lineTo(R * 0.22, -R * 0.68); x.stroke();
        x.beginPath(); x.moveTo(0, -R); x.lineTo(-R * 0.07, -R * 0.88); x.lineTo(0, -R * 0.76); x.lineTo(R * 0.07, -R * 0.88); x.closePath(); x.fill(); x.stroke();
        x.beginPath(); x.moveTo(0, -R * 0.3); x.lineTo(-R * 0.12, -R * 0.4); x.moveTo(0, -R * 0.3); x.lineTo(R * 0.12, -R * 0.4); x.stroke();
      }
    }
    for (var k6 = 0; k6 < 6; k6++) { arm(); x.rotate(Math.PI / 3); }
    var hr = type === 1 ? 0.2 : 0.12;
    x.lineWidth = lw;
    x.beginPath();
    for (var h = 0; h < 6; h++) { var a = h * Math.PI / 3 + Math.PI / 6; var px = Math.cos(a) * R * hr, py2 = Math.sin(a) * R * hr; if (h) x.lineTo(px, py2); else x.moveTo(px, py2); }
    x.closePath(); x.fill(); x.stroke();
    return c;
  }
  function dotSprite(size) {
    var c = document.createElement('canvas'); c.width = c.height = size;
    var x = c.getContext('2d'), g = x.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
    g.addColorStop(0, 'rgba(255,255,255,0.95)'); g.addColorStop(0.45, 'rgba(255,255,255,0.55)'); g.addColorStop(1, 'rgba(255,255,255,0)');
    x.fillStyle = g; x.fillRect(0, 0, size, size); return c;
  }
  function snow(cv, opt) {
    opt = opt || {};
    var ctx = cv.getContext('2d');
    var sharp = [], soft = [], dot = dotSprite(32);
    for (var i = 0; i < 8; i++) sharp.push(flakeSprite(160, 100 + i, false));
    var parts = [], W0 = 0, H0 = 0, crystal = opt.style !== 'soft';
    var density = opt.density || 1;
    function make(fresh) {
      var z = Math.pow(Math.random(), 1.6);
      var p = {
        x: Math.random(), y: fresh ? -0.08 : Math.random() * 1.1 - 0.05, z: z,
        size: crystal ? (9 + z * z * 62) : (3 + z * 9),
        vy: 0.025 + z * 0.075, sway: 0.004 + Math.random() * 0.012, ph: Math.random() * 6.28, fr: 0.4 + Math.random() * 0.9,
        rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * (0.6 + z), spr: Math.floor(Math.random() * 8),
        kind: crystal ? (z < 0.18 ? 'dot' : 'flake') : 'dot'
      };
      return p;
    }
    function setup() {
      var n = Math.round(clamp(cv.clientWidth / 16, 30, 110) * density);
      parts = []; for (var i = 0; i < n; i++) parts.push(make(false));
    }
    function draw(t, dt) {
      if (fit(cv, 2400) || !parts.length) setup();
      var W = cv.width, H = cv.height, sc = W / Math.max(1, cv.clientWidth);
      ctx.clearRect(0, 0, W, H);
      var wind = Math.sin(t * 0.13) * 0.012 + (opt.wind || 0.006);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y += p.vy * dt * (H / sc) / 600;
        p.x += (wind * (0.4 + p.z) + Math.sin(t * p.fr + p.ph) * p.sway) * dt;
        p.rot += p.vr * dt;
        if (p.y > 1.08 || p.x < -0.1 || p.x > 1.1) { parts[i] = make(true); parts[i].x = Math.random() * 1.1 - 0.05; continue; }
        var s = p.size * sc, X = p.x * W, Y = p.y * H;
        var a = crystal ? (0.45 + p.z * 0.55) : (0.35 + p.z * 0.65);
        ctx.globalAlpha = a * (opt.alpha || 1);
        if (p.kind === 'dot') { ctx.drawImage(dot, X - s / 2, Y - s / 2, s, s); continue; }
        var img = sharp[p.spr];
        ctx.save(); ctx.translate(X, Y); ctx.rotate(p.rot); ctx.drawImage(img, -s / 2, -s / 2, s, s); ctx.restore();
      }
      ctx.globalAlpha = 1;
    }
    var run = runner(cv, draw);
    if (RM) { fit(cv, 2400); setup(); draw(0, 0); }
    return { destroy: function () { run.stop(); } };
  }

  /* ---------------- Eis-Glitzer ---------------- */
  function starSprite(size) {
    var c = document.createElement('canvas'); c.width = c.height = size;
    var x = c.getContext('2d');
    x.globalCompositeOperation = 'lighter';
    star(x, size / 2, size / 2, size / 2, 1, 0);
    return c;
  }
  /* regions: Liste von [x0,y0,x1,y1] in Bildpixeln, img: Bildbreite, area: [x0,y0,x1,y1] die der Canvas abdeckt */
  function glitter(cv, opt) {
    var ctx = cv.getContext('2d'), spr = starSprite(128), dot = dotSprite(24);
    var A = opt.area, IW = A[2] - A[0], IH = A[3] - A[1];
    var regs = opt.regions, tot = 0, wts = [];
    regs.forEach(function (r) { var a = (r[2] - r[0]) * (r[3] - r[1]) * (r[4] || 1); wts.push(a); tot += a; });
    function pick() {
      var u = Math.random() * tot, i = 0;
      while (u > wts[i] && i < wts.length - 1) { u -= wts[i]; i++; }
      var r = regs[i];
      return [r[0] + Math.random() * (r[2] - r[0]), r[1] + Math.random() * (r[3] - r[1])];
    }
    var n = opt.count || 34, gl = [], dust = [];
    function mk(now) { var p = pick(); return { x: p[0], y: p[1], t0: now + Math.random() * 2.4, T: 0.55 + Math.random() * 1.1, s: (opt.size || 26) * (0.45 + Math.random() * 0.9), r: Math.random() * 0.5 }; }
    for (var i = 0; i < n; i++) gl.push(mk(0));
    var nd = opt.dust || 0;
    for (var d = 0; d < nd; d++) dust.push({ x: A[0] + Math.random() * IW, y: A[1] + Math.random() * IH * (opt.dustH || 0.6), vx: rnd(-6, 6), vy: rnd(-4, 5), ph: Math.random() * 6.28, s: rnd(2, 5) });
    var level = 1;
    function draw(t, dt) {
      fit(cv, 1600);
      var W = cv.width, k = W / IW;
      ctx.clearRect(0, 0, cv.width, cv.height);
      ctx.save(); ctx.globalCompositeOperation = 'lighter';
      for (var i = 0; i < gl.length; i++) {
        var g = gl[i], u = (t - g.t0) / g.T;
        if (u < 0) continue;
        if (u > 1) { gl[i] = mk(t + Math.random() * 0.8); continue; }
        var e = Math.sin(Math.PI * u); e = e * e;
        var s = g.s * k * (0.35 + 0.65 * e);
        ctx.globalAlpha = e * level;
        ctx.save(); ctx.translate((g.x - A[0]) * k, (g.y - A[1]) * k); ctx.rotate(g.r); ctx.drawImage(spr, -s, -s, 2 * s, 2 * s); ctx.restore();
      }
      for (var j = 0; j < dust.length; j++) {
        var q = dust[j];
        q.x += q.vx * dt; q.y += q.vy * dt;
        if (q.x < A[0]) q.x = A[2]; if (q.x > A[2]) q.x = A[0];
        if (q.y < A[1]) q.y = A[1] + IH * (opt.dustH || 0.6); if (q.y > A[1] + IH * (opt.dustH || 0.6)) q.y = A[1];
        var tw = 0.5 + 0.5 * Math.sin(t * 3 + q.ph);
        ctx.globalAlpha = 0.25 + 0.75 * tw * tw;
        var ss = q.s * k * (0.6 + tw);
        ctx.drawImage(dot, (q.x - A[0]) * k - ss / 2, (q.y - A[1]) * k - ss / 2, ss, ss);
      }
      ctx.restore(); ctx.globalAlpha = 1;
    }
    var run = runner(cv, draw);
    return { destroy: function () { run.stop(); } };
  }

  /* ---------------- Ice Flower: Bohne zieht die Blume ---------------- */
  function skater(cv, opt) {
    var ctx = cv.getContext('2d');
    var A = opt.area, IW = A[2] - A[0], IH = A[3] - A[1];
    var P = opt.path.pts, N = P.length / 2, seg = [], total = 0;
    for (var i = 0; i < N - 1; i++) { var dx = P[2 * i + 2] - P[2 * i], dy = P[2 * i + 3] - P[2 * i + 1], l = Math.sqrt(dx * dx + dy * dy); seg.push(l); total += l; }
    var cum = [0]; for (var c = 0; c < seg.length; c++) cum.push(cum[c] + seg[c]);
    function at(s) {
      s = clamp(s, 0, total);
      var lo = 0, hi = cum.length - 1;
      while (hi - lo > 1) { var mid = (lo + hi) >> 1; if (cum[mid] <= s) lo = mid; else hi = mid; }
      var u = seg[lo] ? (s - cum[lo]) / seg[lo] : 0;
      return [P[2 * lo] + (P[2 * lo + 2] - P[2 * lo]) * u, P[2 * lo + 1] + (P[2 * lo + 3] - P[2 * lo + 1]) * u, lo];
    }
    var img = opt.sprite, ox = opt.path.anchor[0], oy = opt.path.anchor[1];
    var refl = null;
    function mkRefl() {
      if (refl || !img.complete || !img.naturalWidth) return;
      refl = document.createElement('canvas'); refl.width = img.naturalWidth; refl.height = img.naturalHeight;
      var r = refl.getContext('2d');
      r.translate(0, refl.height); r.scale(1, -1); r.drawImage(img, 0, 0);
      r.setTransform(1, 0, 0, 1, 0, 0);
      r.globalCompositeOperation = 'destination-in';
      var g = r.createLinearGradient(0, 0, 0, refl.height);
      g.addColorStop(0, 'rgba(0,0,0,0.95)'); g.addColorStop(0.45, 'rgba(0,0,0,0.35)'); g.addColorStop(1, 'rgba(0,0,0,0)');
      r.fillStyle = g; r.fillRect(0, 0, refl.width, refl.height);
    }
    var dur = opt.duration || 15, state = 'idle', t0 = 0, fade = 0, spray = [], face = 1, lean = 0, kScale = 1, onDone = opt.onDone;
    var startDelay = opt.delay == null ? 0.8 : opt.delay, armed = false, now = 0;
    function ease(u) { return u < 0.04 ? u * u / 0.08 : u > 0.96 ? 1 - (1 - u) * (1 - u) / 0.08 : u; }
    function draw(t, dt) {
      now = t;
      fit(cv, 1600);
      mkRefl();
      var W = cv.width, H = cv.height, k = W / IW;
      if (!armed && opt.autoplay !== false) { armed = true; t0 = t + startDelay; state = 'run'; }
      var posS = 0;
      if (state === 'run') {
        var u = clamp((t - t0) / dur, 0, 1);
        posS = ease(u) * total;
        drawnMax = posS;
        if (u >= 1) { state = 'done'; if (onDone) onDone(); }
      } else if (state === 'done' || state === 'static') {
        posS = total; drawnMax = total;
      } else if (state === 'clear') {
        fade -= dt * 2.2;
        if (fade <= 0) { drawnMax = 0; state = 'run'; t0 = t + 0.25; }
        posS = 0;
      }
      lastS = posS;
      ctx.clearRect(0, 0, W, H);
      var showS = state === 'clear' ? drawnMax : posS;
      if (showS > 1) {
        var end = at(showS), last = end[2];
        ctx.save();
        ctx.scale(k, k); ctx.translate(-A[0], -A[1]);
        ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        ctx.beginPath(); ctx.moveTo(P[0], P[1]);
        for (var pi = 1; pi <= last; pi++) ctx.lineTo(P[2 * pi], P[2 * pi + 1]);
        ctx.lineTo(end[0], end[1]);
        var fa = state === 'clear' ? Math.max(0, fade) : 1;
        ctx.globalAlpha = 0.12 * fa; ctx.strokeStyle = '#F2FBFF'; ctx.lineWidth = 7; ctx.stroke();
        ctx.globalAlpha = 0.55 * fa; ctx.strokeStyle = '#EEF9FF'; ctx.lineWidth = 3.1; ctx.stroke();
        ctx.globalAlpha = 0.45 * fa; ctx.strokeStyle = '#7FB7CF'; ctx.lineWidth = 1.1; ctx.stroke();
        ctx.restore();
        ctx.globalAlpha = 1;
      }
      // Position, Richtung, Neigung
      var p = at(posS), q = at(Math.min(total, posS + 14)), b = at(Math.max(0, posS - 14));
      var vx = q[0] - b[0], vy = q[1] - b[1];
      if (state === 'run' && Math.abs(vx) > 2) face += ((vx > 0 ? 1 : -1) - face) * Math.min(1, dt * 6);
      if (state !== 'run') face += (1 - face) * Math.min(1, dt * 3);
      var q2 = at(Math.min(total, posS + 30)), b2 = at(Math.max(0, posS - 30));
      var a1 = Math.atan2(q2[1] - p[1], q2[0] - p[0]), a0 = Math.atan2(p[1] - b2[1], p[0] - b2[0]);
      var dA = a1 - a0; while (dA > Math.PI) dA -= 2 * Math.PI; while (dA < -Math.PI) dA += 2 * Math.PI;
      var targetLean = state === 'run' ? clamp(dA * 0.9, -0.22, 0.22) : 0;
      lean += (targetLean - lean) * Math.min(1, dt * 5);
      var persp = 1 + (p[1] - 604) * 0.0011;
      var bob = state === 'run' ? Math.sin(t * 9.5) * 1.6 : 0;
      var X = (p[0] - A[0]) * k, Y = (p[1] - A[1]) * k;
      if (state === 'run' && Math.random() < Math.min(1, Math.abs(dA) * 6) * 0.9) {
        for (var s2 = 0; s2 < 2; s2++) spray.push({ x: p[0] + rnd(-6, 6), y: p[1] + rnd(-2, 2), vx: -vx * rnd(0.6, 1.6) + rnd(-25, 25), vy: rnd(-30, -8), life: rnd(0.35, 0.7), age: 0, s: rnd(1.2, 2.6) });
      }
      ctx.save();
      for (var i = spray.length - 1; i >= 0; i--) {
        var sp = spray[i]; sp.age += dt;
        if (sp.age > sp.life) { spray.splice(i, 1); continue; }
        sp.x += sp.vx * dt; sp.y += sp.vy * dt; sp.vy += 90 * dt;
        ctx.globalAlpha = (1 - sp.age / sp.life) * 0.9;
        ctx.fillStyle = '#F4FBFF';
        ctx.beginPath(); ctx.arc((sp.x - A[0]) * k, (sp.y - A[1]) * k, sp.s * k, 0, Math.PI * 2); ctx.fill();
      }
      ctx.restore();
      if (img.complete && img.naturalWidth) {
        var sw = img.naturalWidth * k * persp, sh = img.naturalHeight * k * persp;
        // Schatten
        ctx.save();
        ctx.globalAlpha = 0.18;
        ctx.fillStyle = '#0A3346';
        ctx.beginPath(); ctx.ellipse(X + 6 * k, Y + 6 * k, 64 * k * persp, 9 * k * persp, 0, 0, Math.PI * 2); ctx.fill();
        ctx.restore();
        // Spiegelung
        if (refl) {
          ctx.save();
          ctx.translate(X, Y + 10 * k * persp);
          ctx.scale(face, 1.5);
          ctx.globalAlpha = 0.24;
          ctx.drawImage(refl, -ox * k * persp, 0, sw, sh);
          ctx.restore();
        }
        ctx.save();
        ctx.translate(X, Y + bob * k);
        ctx.rotate(lean);
        ctx.scale(face, 1);
        ctx.drawImage(img, -ox * k * persp, -oy * k * persp, sw, sh);
        ctx.restore();
      }
    }
    var lastS = 0, drawnMax = 0;
    var run = runner(cv, draw);
    if (RM || opt.autoplay === false && opt.static) {
      state = 'static'; armed = true; drawnMax = total;
    }
    return {
      replay: function () {
        if (RM) return;
        if (state === 'idle') { armed = true; state = 'run'; t0 = now + 0.1; run.kick(); return; }
        fade = 1; state = 'clear'; run.kick();
      },
      destroy: function () { run.stop(); }
    };
  }

  /* ---------------- Kamin: Flammen, Glut, Funken ---------------- */
  function fire(cv, opt) {
    var ctx = cv.getContext('2d');
    var A = opt.area, IW = A[2] - A[0];
    var clip = opt.clip, base = opt.base; // base: [x0,x1,y]
    var parts = [], embers = [], on = false, level = 0, glow = opt.glow, unlit = opt.unlit, room = opt.room;
    var noiseT = 0;
    function draw(t, dt) {
      level += ((on ? 1 : 0) - level) * Math.min(1, dt * 1.6);
      fit(cv, 900);
      var W = cv.width, H = cv.height, k = W / IW;
      ctx.clearRect(0, 0, W, H);
      noiseT += dt;
      var flick = 0.78 + 0.12 * Math.sin(t * 11.3) + 0.07 * Math.sin(t * 23.7 + 1.3) + 0.06 * Math.sin(t * 5.1 + 0.4) + (Math.random() - 0.5) * 0.06;
      if (glow) { glow.style.opacity = (level * clamp(flick, 0.55, 1.05)).toFixed(3); }
      if (room) { room.style.opacity = (level * (0.85 + 0.15 * flick)).toFixed(3); }
      if (unlit) { unlit.style.opacity = (1 - level).toFixed(3); }
      if (level < 0.01 && !parts.length && !embers.length) return;
      var rate = 110 * level;
      var nNew = rate * dt + Math.random();
      for (var i = 0; i < Math.floor(nNew); i++) {
        var x = rnd(base[0], base[1]);
        var mid = (base[0] + base[1]) / 2, spread = (base[1] - base[0]) / 2;
        var hgt = 1 - Math.pow(Math.abs(x - mid) / spread, 2) * 0.6;
        parts.push({ x: x, y: base[2] + rnd(-6, 4), vx: rnd(-6, 6), vy: -rnd(55, 120) * hgt, life: rnd(0.45, 1.0) * hgt + 0.15, age: 0, s: rnd(14, 26), ph: Math.random() * 6.28 });
      }
      if (Math.random() < dt * 5 * level) embers.push({ x: rnd(base[0] + 10, base[1] - 10), y: base[2] - rnd(0, 20), vx: rnd(-14, 14), vy: -rnd(40, 95), life: rnd(1.2, 2.6), age: 0, s: rnd(1.2, 2.4) });
      ctx.save();
      ctx.beginPath();
      for (var c = 0; c < clip.length; c++) { var cx = (clip[c][0] - A[0]) * k, cy = (clip[c][1] - A[1]) * k; if (c) ctx.lineTo(cx, cy); else ctx.moveTo(cx, cy); }
      ctx.closePath(); ctx.clip();
      ctx.globalCompositeOperation = 'lighter';
      for (var j = parts.length - 1; j >= 0; j--) {
        var p = parts[j]; p.age += dt;
        var u = p.age / p.life;
        if (u >= 1) { parts.splice(j, 1); continue; }
        p.x += (p.vx + Math.sin(t * 7 + p.ph) * 18 * u) * dt; p.y += p.vy * dt; p.vy *= (1 - dt * 0.4);
        var r = p.s * (1 - u * 0.75) * k, X = (p.x - A[0]) * k, Y = (p.y - A[1]) * k;
        var col = u < 0.25 ? [255, 236, 190] : u < 0.55 ? [255, 168, 64] : [214, 70, 22];
        var a = (u < 0.15 ? u / 0.15 : 1 - (u - 0.15) / 0.85) * 0.2 * level;
        ctx.save(); ctx.translate(X, Y); ctx.scale(0.75, 1.25);
        var g = ctx.createRadialGradient(0, 0, 0, 0, 0, r);
        g.addColorStop(0, 'rgba(' + col[0] + ',' + col[1] + ',' + col[2] + ',' + a + ')');
        g.addColorStop(1, 'rgba(' + col[0] + ',' + col[1] + ',' + col[2] + ',0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(0, 0, r, 0, Math.PI * 2); ctx.fill(); ctx.restore();
      }
      for (var e = embers.length - 1; e >= 0; e--) {
        var m = embers[e]; m.age += dt;
        if (m.age > m.life) { embers.splice(e, 1); continue; }
        m.x += (m.vx + Math.sin(t * 4 + e) * 10) * dt; m.y += m.vy * dt;
        var aa = (1 - m.age / m.life) * level;
        ctx.fillStyle = 'rgba(255,' + (150 + Math.floor(80 * (1 - m.age / m.life))) + ',60,' + aa + ')';
        ctx.beginPath(); ctx.arc((m.x - A[0]) * k, (m.y - A[1]) * k, m.s * k, 0, Math.PI * 2); ctx.fill();
      }
      ctx.restore();
    }
    var run = runner(cv, draw);
    return {
      setOn: function (v) { on = !!v; run.kick(); if (RM) { if (glow) glow.style.opacity = on ? '0.9' : '0'; if (room) room.style.opacity = on ? '0.9' : '0'; if (unlit) unlit.style.opacity = on ? '0' : '1'; } },
      destroy: function () { run.stop(); }
    };
  }

  /* ---------------- Knistern (Web Audio, ohne Audiodatei) ---------------- */
  function crackle() {
    var AC = window.AudioContext || window.webkitAudioContext;
    var ctx = null, master = null, timer = 0, bedGain = null, hissGain = null, bank = null, active = false, modT = 0;
    function makeBank(sr) {
      var b = { tick: [], snap: [], pop: [] };
      function buf(sec, fn) {
        var n = Math.max(8, Math.floor(sr * sec)), B = ctx.createBuffer(1, n, sr), d = B.getChannelData(0), peak = 0, hp = 0, prev = 0;
        for (var i = 0; i < n; i++) { var v = fn(i / sr, i); hp = 0.97 * (hp + v - prev); prev = v; d[i] = hp; if (Math.abs(hp) > peak) peak = Math.abs(hp); }
        for (var j = 0; j < n; j++) d[j] /= (peak || 1);
        return B;
      }
      for (var i = 0; i < 36; i++) {
        var f = rnd(1800, 7500), tau = rnd(0.00035, 0.0013), ph = Math.random() * 6.28, mix = rnd(0.3, 0.8);
        b.tick.push(buf(0.012, function (t) { return ((Math.random() * 2 - 1) * mix + Math.sin(6.283 * f * t + ph) * (1 - mix)) * Math.exp(-t / tau); }));
      }
      for (var s = 0; s < 14; s++) {
        var f1 = rnd(1100, 2600), tn = rnd(0.002, 0.005), tr = rnd(0.006, 0.012), th = rnd(95, 150);
        b.snap.push(buf(0.06, function (t) { return (Math.random() * 2 - 1) * Math.exp(-t / tn) + 0.7 * Math.sin(6.283 * f1 * t) * Math.exp(-t / tr) + 0.5 * Math.sin(6.283 * th * t) * Math.exp(-t / 0.018); }));
      }
      for (var p = 0; p < 5; p++) {
        var f2 = rnd(600, 1050), tn2 = rnd(0.004, 0.008);
        b.pop.push(buf(0.12, function (t) { return (Math.random() * 2 - 1) * Math.exp(-t / tn2) + 0.9 * Math.sin(6.283 * f2 * t) * Math.exp(-t / 0.016) + 0.8 * Math.sin(6.283 * 78 * t) * Math.exp(-t / 0.04); }));
      }
      return b;
    }
    function play(B, when, gain, pan) {
      var s = ctx.createBufferSource(); s.buffer = B;
      s.playbackRate.value = rnd(0.85, 1.2);
      var g = ctx.createGain(); g.gain.value = gain;
      if (ctx.createStereoPanner) { var p = ctx.createStereoPanner(); p.pan.value = pan; s.connect(g); g.connect(p); p.connect(master); }
      else { s.connect(g); g.connect(master); }
      s.start(when);
    }
    var mode = 0, modeUntil = 0;
    function schedule() {
      if (!active) return;
      var now = ctx.currentTime, horizon = now + 0.25;
      if (now > modeUntil) { mode = Math.random() < 0.35 ? 1 : 0; modeUntil = now + rnd(0.6, mode ? 1.8 : 3.5); }
      var rate = mode ? 16 : 4.5;
      var t = Math.max(now + 0.01, nextT);
      while (t < horizon) {
        var r = Math.random(), pan = rnd(-0.55, 0.55);
        if (r < 0.74) {
          var n = 1 + Math.floor(Math.random() * Math.random() * 5), tt = t;
          for (var i = 0; i < n; i++) { play(bank.tick[Math.floor(Math.random() * bank.tick.length)], tt, Math.min(0.9, 0.06 * Math.exp(rnd(0, 2.3))), clamp(pan + rnd(-0.1, 0.1), -1, 1)); tt += rnd(0.004, 0.03); }
        } else if (r < 0.97) {
          play(bank.snap[Math.floor(Math.random() * bank.snap.length)], t, rnd(0.18, 0.42), pan);
        } else {
          play(bank.pop[Math.floor(Math.random() * bank.pop.length)], t, rnd(0.45, 0.7), pan);
          var tt2 = t + 0.03;
          for (var j = 0; j < 6 + Math.floor(Math.random() * 7); j++) { tt2 += rnd(0.012, 0.06); play(bank.tick[Math.floor(Math.random() * bank.tick.length)], tt2, rnd(0.05, 0.25), clamp(pan + rnd(-0.3, 0.3), -1, 1)); }
        }
        t += -Math.log(1 - Math.random()) / rate;
      }
      nextT = t;
      // Flammen-Rauschen langsam bewegen
      if (now > modT) {
        modT = now + rnd(0.2, 0.5);
        bedGain.gain.setTargetAtTime(rnd(0.05, 0.13), now, 0.25);
        hissGain.gain.setTargetAtTime(Math.random() < 0.15 ? rnd(0.006, 0.016) : 0.0015, now, 0.3);
      }
      timer = setTimeout(schedule, 90);
    }
    var nextT = 0;
    return {
      start: function () {
        if (!AC || active) return;
        ctx = new AC();
        if (ctx.state === 'suspended' && ctx.resume) ctx.resume();
        var comp = ctx.createDynamicsCompressor();
        comp.threshold.value = -10; comp.ratio.value = 4; comp.attack.value = 0.002; comp.release.value = 0.12;
        master = ctx.createGain(); master.gain.value = 0;
        master.connect(comp); comp.connect(ctx.destination);
        master.gain.setTargetAtTime(0.85, ctx.currentTime, 0.4);
        var sr = ctx.sampleRate;
        // tiefes Lodern (braunes Rauschen, Tiefpass)
        var nb = ctx.createBuffer(1, sr * 3, sr), d = nb.getChannelData(0), last = 0;
        for (var i = 0; i < d.length; i++) { last = (last + 0.02 * (Math.random() * 2 - 1)) / 1.02; d[i] = last * 3.5; }
        var bed = ctx.createBufferSource(); bed.buffer = nb; bed.loop = true;
        var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 210; lp.Q.value = 0.4;
        bedGain = ctx.createGain(); bedGain.gain.value = 0.08;
        bed.connect(lp); lp.connect(bedGain); bedGain.connect(master); bed.start();
        // seltenes Zischen von Harz
        var wb = ctx.createBuffer(1, sr * 2, sr), w = wb.getChannelData(0);
        for (var j = 0; j < w.length; j++) w[j] = Math.random() * 2 - 1;
        var hs = ctx.createBufferSource(); hs.buffer = wb; hs.loop = true;
        var hp = ctx.createBiquadFilter(); hp.type = 'highpass'; hp.frequency.value = 5000;
        hissGain = ctx.createGain(); hissGain.gain.value = 0.0015;
        hs.connect(hp); hp.connect(hissGain); hissGain.connect(master); hs.start();
        bank = makeBank(sr);
        active = true; nextT = ctx.currentTime + 0.05; modT = 0;
        schedule();
      },
      stop: function () {
        active = false;
        if (timer) clearTimeout(timer);
        if (ctx) { var c = ctx; try { master.gain.setTargetAtTime(0, c.currentTime, 0.15); } catch (e) {} setTimeout(function () { try { c.close(); } catch (e) {} }, 500); }
        ctx = null;
      },
      isOn: function () { return active; }
    };
  }

  return { RM: RM, fit: fit, runner: runner, discoBall: discoBall, discoSpots: discoSpots, snow: snow, glitter: glitter, skater: skater, fire: fire, crackle: crackle };
})();
